import { render, staticRenderFns } from "./GestionUsuario.vue?vue&type=template&id=486490ca&scoped=true&lang=pug"
import script from "./GestionUsuario.vue?vue&type=script&lang=js"
export * from "./GestionUsuario.vue?vue&type=script&lang=js"
import style0 from "./GestionUsuario.vue?vue&type=style&index=0&id=486490ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486490ca",
  null
  
)

export default component.exports